import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, shareReplay } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import SafeUrlAssembler from 'safe-url-assembler';
import { ApiEndpointService } from '../../../../core/services/api-endpoint.service';
import { RequestMethodTypes } from '../../../enum/general-enum';
import { ICustomerImage } from '../models/customer-image.interface';
import { IPaperlessCommercialInvoiceCapability } from '../models/paperless-commercial-invoice-capability.interface';
import { IPaperlessCommercialInvoiceEnrollment } from '../models/paperless-commercial-invoice-enrollment.interface';

@Injectable()
export class PaperlessCommercialInvoiceService {
    public isEnrolledClickedPaperlessCommercialInvoice$ = new BehaviorSubject<boolean>(false);
    public uploadCustomerDocumentsErrorMessage$ = new BehaviorSubject<string>('');
    public uploadCustomerDocumentsLetterHeadAndSignatureErrorMessage$ = new BehaviorSubject<string>('');

    constructor(private httpClient: HttpClient,
                private apiEndpointService: ApiEndpointService,
    ) {
    }

    public getCustomerImages(): Observable<ICustomerImage[]> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('getCustomerImages'))
            .toString();
        return this.httpClient.get<ICustomerImage[]>(endpoint);
    }

    public enrollPaperlessCommercialInvoice(data: IPaperlessCommercialInvoiceEnrollment): Observable<any> {
        // TODO: Blocked by MV3-2951.
        return of({});
        // const endpoint = SafeUrlAssembler()
        //   .template(this.apiEndpointService.getEndpoint('enrollPaperlessCommercialInvoice'))
        //   .toString();
        // return this.httpClientService.post(endpoint, data);
    }

    public uploadCustomerDocuments(data: ICustomerImage[]): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('uploadCustomerDocuments'))
            .toString();
        return this.httpClient.post(endpoint, data);
    }

    public deleteCustomerDocument(id: number): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('deleteCustomerDocument'))
            .param('id', id)
            .toString();
        return this.httpClient.delete(endpoint);
    }

    public deleteCustomerDocuments(data: { LinkID: number }[] | any): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('deleteCustomerDocuments'))
            .toString();
        //return this.httpClientService.delete<any>( endpoint, data);
        // TODO: check why we need to send a payload with a DELETE request.
        //  If necessary, we can use a URL parameter instead.
        return this.httpClient.request(RequestMethodTypes.DELETE, endpoint, data);
    }

    public validatePaperlessInvoiceCapability(shipFromCountryCode: string, shipToCountryCode: string):
        Observable<IPaperlessCommercialInvoiceCapability> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('validatePaperlessInvoiceCapability'))
            .toString();

        const data = {
            ShipFromCountry: shipFromCountryCode,
            ShipToCountry: shipToCountryCode,
        };

        return this.httpClient.post<IPaperlessCommercialInvoiceCapability>(endpoint, data)
                   .pipe(
                       debounceTime(300),
                       distinctUntilChanged(),
                       shareReplay(1),
                   );
    }

    public updateCustomerCommercialInvoiceType(id: number): Observable<any> {
        const endpoint = SafeUrlAssembler()
            .template(this.apiEndpointService.getEndpoint('updateCustomerCommercialInvoiceType'))
            .param('id', id)
            .toString();
        return this.httpClient.put<boolean>(endpoint, {'id': id});
    }
}
